import React, { useEffect } from "react";
import FormLottery from "./blocks/FormLottery";
import FilterCalendar from "./FilterCalendar";
import { getDateSlash } from "../../../utility/DateUtils";
import ResultNight from "../../results/night/ResultNight";
import ResultDay from "../../results/day/ResultDay";
import Waiting from "./blocks/Waiting";
import _ from "lodash";

const MidSideFilter = ({ ...props }) => {
  const { onChangeDate } = props;
  const {
    results: {
      data: { items, nextDraw },
    },
    match: { params },
    fetchResults,
    draw,
  } = props;

  useEffect(() => {
    const date = params.date.replaceAll(".html", "");
    let filterByDate = date.split("-").reverse().join("-");
    fetchResults({
      filterByDate: filterByDate,
    });
  }, [fetchResults, params.date]);

  return (
    <td>
      <div id="right_main">
        <table style={{ width: "100%", cellSpacing: "0", cellPadding: "0" }}>
          <tbody>
            <tr>
              <td className="main">
                <div className="mainbody">
                  <div id="noidung">
                    <h1 className="pagetitle">
                      KẾT QUẢ XỔ SỐ KIẾN THIẾT {getDateSlash()}
                    </h1>
                    <div className="box_mienuutien">
                      <FormLottery />
                    </div>
                    {_.isEmpty(draw) && nextDraw && (
                      <Waiting nextDraw={nextDraw} />
                    )}
                    <FilterCalendar
                      onChangeDate={(date) => onChangeDate(date)}
                    />

                    {!_.isEmpty(draw) &&
                      (draw?.isNight ? (
                        <ResultNight isDraw items={draw} {...props} />
                      ) : (
                        <ResultDay items={draw} {...props} />
                      ))}

                    {items?.map((items, i) => {
                      return (
                        <div key={i}>
                          {items?.isNight ? (
                            <ResultNight items={items} {...props} />
                          ) : (
                            <ResultDay
                              indexResult={i}
                              items={items}
                              {...props}
                            />
                          )}
                        </div>
                      );
                    })}

                    <div className="clear" />
                    <FilterCalendar
                      onChangeDate={(date) => onChangeDate(date)}
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </td>
  );
};

export default MidSideFilter;
